import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
`;

export const Body = styled.div`
  display: flex;
  width: 100%;
`;